import Config from "../Config";
import { useState, useEffect, useRef } from "react";

import direction from "../constants/SortOrder";

export const useLocalPaginatedRequest = (
    requestFn = () => Promise.resolve(),
    params = {},
    deps = [],
    searchKey = "Q",
    dataKey = "data",
    totalKey = "count",
    dataId = null 
) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(Config.LIMIT);
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState("");
    const [total, setTotal] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const requestAbortController = useRef(null);

    useEffect(() => {
        requestAbortController.current = new AbortController();

        request();

        return () => {
            if (requestAbortController.current) {
                requestAbortController.current.abort();
            }
        };
        // eslint-disable-next-line
    }, [page,pageSize, searchText, ...deps]);

    const request = () => {
        setIsFetching(true);
        requestFn(
            {
                limit: pageSize,
                page: page,
                // direction: direction.DESC,
                // column: "CreatedAt",
                ...(searchText && { [searchKey]: searchText }),
                ...(Object.keys(params).length && params)
            },
            requestAbortController.current.signal,
            dataId
        )
            .then((res) => {
                setData(res[dataKey]);
                setTotal(res[totalKey]);
            })
            .finally(() => {
                setIsFetching(false);
            });
    };

    const handleSearchChange = (e) => {
        let searchText = e.target.value;
        setSearchText(searchText);
        setPage(1);
    };

    const handlePageClick = (pageNo) => {
        setPage(pageNo);
    };

    const onChangePageSize = (event) => {
        setPageSize(Number(event.target.value));
        setPage(1); 
    };

    const setPageToOne = () => {
        setPage(1);
    }

    return {
        page,
        searchText,
        data,
        total,
        isFetching,
        request,
        pageSize,
        onChangePageSize,
        handleSearchChange,
        handlePageClick,
        setPageToOne
    };
};
